// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  LlmKeySource,
} from "./types";

export default {
  project: __t.string(),
  model: __t.string(),
  inputTokens: __t.u64(),
  cachedInputTokens: __t.u64(),
  outputTokens: __t.u64(),
  get keySource() {
    return LlmKeySource;
  },
};
